import useClassNames from '@medflex/hooks/useClassNames';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/solid';
import AvatarSupportPatient from '../../assets/avatar-support-patient.png';
import Button from '../Button';

const SupportAndFeedback = ({ className, onClickSupportChat }) => {
  const cn = useClassNames(() => ['flex', 'flex-col', 'text-slate-600', className], [className]);
  const { t } = useTranslation('components');

  return (
    <div className={cn}>
      <h3 className="font-semibold text-xl inline-flex items-center">
        <ChatBubbleLeftRightIcon className="w-6 w-6" />
        <span className="ml-2">{t('Sessions.SupportAndFeedback.title')}</span>
      </h3>
      <div className="flex flex-auto items-center bg-blue-100 p-6">
        <img
          src={AvatarSupportPatient}
          alt="Avatar Support"
          className="block object-contain rounded-full w-16 h-16 mb-2"
        />
        <div className="ml-4">
          <div>{t('Sessions.SupportAndFeedback.text')}</div>
          <Button kind="link" onClick={onClickSupportChat}>
            {t('Sessions.SupportAndFeedback.cta')}
          </Button>
        </div>
      </div>
    </div>
  );
};

SupportAndFeedback.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  onClickSupportChat: PropTypes.func,
};

SupportAndFeedback.defaultProps = {
  onClickSupportChat: () => {},
};

export default SupportAndFeedback;
